import Input from "../atoms/Input";
import "./ControlPanelList.css";
import { Search } from "lucide-react";

interface ControlPanelListSearchProps {
    search: string;
    setSearch: (v: string) => void;
    type: string;
}

function ControlPanelListSearch(props: ControlPanelListSearchProps) {
    return (
        <Input
            id={props.type}
            name={props.type}
            value={props.search}
            placeholder={`Search ${props.type}...`}
            onChange={(e) => props.setSearch(e.target.value)}
            onClear={() => props.setSearch("")}
            startIcon={<Search size={16} />}
        />
    );
}

export default ControlPanelListSearch;
